import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/react'
import { dark } from '@clerk/themes'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/globals.css'

// Read from env (never hardcoded). Clerk React v6 types require the prop.
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY in .env')
}

// Apply Clerk's built-in dark baseTheme globally so sign-in / sign-up modals
// and any other Clerk components render with legible dark surfaces instead
// of the default light theme. Brand-tint the accent with our neon.
//
// IMPORTANT: do NOT override colorBackground / colorInputBackground /
// colorText here. The dark baseTheme paints every internal surface in a
// coordinated palette; overriding individual colors produces dark-on-dark
// text bleed on unrelated elements (headings, labels, muted text). Only
// the primary accent is safe to override — everything else stays stock.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      appearance={{
        baseTheme: dark,
        variables: {
          colorPrimary: '#39FF14',
          colorTextOnPrimaryBackground: '#0a0a0a',
        },
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </StrictMode>,
)
